import React from 'react';
import PropTypes from 'prop-types';
import AlertIcon from '../../../../resources/images/alert-triangle-red.svg';
import './summarizeErrors.scss';

const SummarizeFormErrors = ({ errorFields = [], authorableError }) => {
    return (
        <div className="sumFormErrors" role="alert">
            <AlertIcon tabIndex="-1" aria-hidden={true} />
            <div className="error_block">
                <p dangerouslySetInnerHTML={{ __html: authorableError }} />
                {errorFields.length > 0 && (
                    <ul className="error">
                        {errorFields.map(
                            (error, index) =>
                                error && (
                                    <li key={index} className="requiredSymbol">
                                        {error}
                                    </li>
                                )
                        )}
                    </ul>
                )}
            </div>
        </div>
    );
};

SummarizeFormErrors.propTypes = {
    errorFields: PropTypes.array,
    authorableError: PropTypes.string
};

SummarizeFormErrors.defaultProps = {
    authorableError: ''
};

export default SummarizeFormErrors;
